/**
 * A sum rounded to cents exactly as it is shown: with the same number formatting as the
 * shown numbers (formatGroupedNumber), e.g. 292,215 as 292,22
 */
export const toShownCents = (value: number): number =>
  Number.isFinite(value)
    ? Number(
        value.toLocaleString('en-US', {
          maximumFractionDigits: 2,
          useGrouping: false,
        })
      )
    : 0;

/**
 * The difference of two sums as their shown values give it, e.g. the margin shown between
 * the shown selling price and expense: 385,00 € − 292,22 € = 92,78 €, also when the exact
 * margin is 92,785 €. It differs from the exact difference by less than a cent, and only
 * what is shown uses it; percentages and further calculations use the exact values.
 */
const getShownDifference = (minuend: number, subtrahend: number): number =>
  toShownCents(minuend) - toShownCents(subtrahend);

export default getShownDifference;
